import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, icon, iconColor, iconBg, description, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-4 shadow-sm animate-pulse">
        <div className="h-4 bg-muted rounded w-1/2 mb-3"></div>
        <div className="h-8 bg-muted rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-muted rounded w-1/3"></div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <p className="text-2xl font-bold text-foreground">{value}</p>
        </div>
        <div className={`p-2 rounded-lg ${iconBg}`}>
          <Icon name={icon} size={20} className={iconColor} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{description}</p>
    </div>
  );
};

export default StatsCard;